import {
  ProjectImg,
  ProjectLink,
  ProjectsHeading,
  ProjectsWrapper,
  ProjectsSectionWrapper,
  SingleProjectWrapper,
  ProjectHeading,
  ProjectText,
  ImgWrapper,
} from "./Projects.style";

const Projects = () => {
  return (
    <ProjectsSectionWrapper id="projects">
      <ProjectsHeading>Projects</ProjectsHeading>
      <ProjectsWrapper>
        <SingleProjectWrapper>
          <ImgWrapper>
            <ProjectImg
              src="https://images.unsplash.com/photo-1654277041218-84424c78f0ae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=862&q=80"
              alt="project image"
            />
          </ImgWrapper>
          <ProjectHeading>GitHub Profile Finder</ProjectHeading>
          <ProjectText>
            Projeto desenvolvido em <strong>ReactJS</strong> com o intuito de
            consumir a API do GitHub, a qual retorna os dados do usuário de
            acordo com o nome de usuário inserido na busca.
          </ProjectText>
          <ProjectLink
            href="https://github.com/jpcchaves/github-profile-finder"
            target="_blank"
          >
            Ver projeto
          </ProjectLink>
        </SingleProjectWrapper>
        <SingleProjectWrapper>
          <ImgWrapper>
            <ProjectImg
              src="https://images.pexels.com/photos/262508/pexels-photo-262508.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="project image"
            />
          </ImgWrapper>
          <ProjectHeading>MiniBLOG</ProjectHeading>
          <ProjectText>
            Projeto desenvolvido em <strong>ReactJS</strong>. O intuito do
            projeto foi integrar o FrontEnd (ReactJS) com o Backend (Firebase),
            realizando a comunicação com o servidor e armazenando os dados dos
            posts.
          </ProjectText>
          <ProjectLink
            href="https://github.com/jpcchaves/miniBlogProject"
            target="_blank"
          >
            Ver projeto
          </ProjectLink>
        </SingleProjectWrapper>
        <SingleProjectWrapper>
          <ImgWrapper>
            <ProjectImg
              src="https://images.unsplash.com/photo-1542204165-65bf26472b9b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
              alt="project image"
            />
          </ImgWrapper>
          <ProjectHeading>Movies Lib</ProjectHeading>
          <ProjectText>
            Projeto desenvolvido em <strong>ReactJS</strong> com o intuito de
            consumir a API do TMDB, a qual retorna os dados de filmes, os quais
            são mostrados na tela e ordenados da melhor para pior avaliação.
          </ProjectText>
          <ProjectLink
            href="https://github.com/jpcchaves/movies-library"
            target="_blank"
          >
            Ver projeto
          </ProjectLink>
        </SingleProjectWrapper>
        <SingleProjectWrapper>
          <ImgWrapper>
            <ProjectImg
              src="https://images.pexels.com/photos/2253275/pexels-photo-2253275.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="project image"
            />
          </ImgWrapper>
          <ProjectHeading>SoftPETS</ProjectHeading>
          <ProjectText>
            Esse projeto foi desenvolvido utilizando as tecnologias{" "}
            <strong>ReactJS</strong> no Front-End e{" "}
            <strong>Firebase/Firestore</strong> no Back-End. Trata-se de um
            projeto de PetShop com a finalidade de listar, visualizar, criar,
            editar e excluir animais de estimação de um PetShop.
          </ProjectText>
          <ProjectLink
            href="https://github.com/jpcchaves/desafio-junior-1"
            target="_blank"
          >
            Ver projeto
          </ProjectLink>
        </SingleProjectWrapper>
        <SingleProjectWrapper>
          <ImgWrapper>
            <ProjectImg
              src="https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
              alt="project image"
            />
          </ImgWrapper>
          <ProjectHeading>Cadastro de Usuários</ProjectHeading>
          <ProjectText>
            Esse é um projeto de cadastro de usuário criado com a tecnologia
            <strong> ReactJS</strong>. O intuito do projeto foi integrar o
            FrontEnd (criado em ReactJS) com o Backend (criado com JSON-Server).
            Realizando o <strong>C.R.U.D</strong> para fazer a comunicação do
            Frontend com o Backend.
          </ProjectText>
          <ProjectLink
            href="https://github.com/jpcchaves/Cadastro-Usuario-ReactJS"
            target="_blank"
          >
            Ver projeto
          </ProjectLink>
        </SingleProjectWrapper>
        <SingleProjectWrapper>
          <ImgWrapper>
            <ProjectImg
              src="https://images.pexels.com/photos/11874074/pexels-photo-11874074.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="project image"
            />
          </ImgWrapper>
          <ProjectHeading>Calculadora</ProjectHeading>
          <ProjectText>
            Projeto desenvolvido em <strong>ReactJS</strong> com o intuito de
            reproduzir uma calculadora real e funcional com as operações
            básicas. Este foi um dos meus primeiros projetos utilizando ReactJS.
          </ProjectText>
          <ProjectLink
            href="https://github.com/jpcchaves/Calculadora"
            target="_blank"
          >
            Ver projeto
          </ProjectLink>
        </SingleProjectWrapper>
      </ProjectsWrapper>
    </ProjectsSectionWrapper>
  );
};

export default Projects;
